import { triniumApi } from '@api/Trinium/slice';
import { Driver, transformDriverResponse, transformDriversResponse } from './types';

const driverSlice = triniumApi.injectEndpoints({
	endpoints: (builder) => ({
		fetchDrivers: builder.query<
			Driver[],
			{
				terminalNumber: string;
				startsWith?: string;
				isActive?: boolean;
			}
		>({
			query: ({ terminalNumber, startsWith, isActive }) => ({
				url: `/${terminalNumber}/drivers`,
				params: {
					startsWith,
					isActive
				}
			}),
			transformResponse: transformDriversResponse,
			keepUnusedDataFor: 180,
			providesTags: (result) => {
				if (!result) return [];

				// We are providing tags for the driver/tractor combination so that
				// a refresh can be determined should the driver be assigned a new tractor
				return [
					...result.map(({ id }) => ({
						type: 'drivers' as const,
						id: id
					}))
				];
			}
		}),

		fetchDriver: builder.query<Driver, { terminalNumber: string; id: string }>({
			query: (params) => ({
				url: `${params.terminalNumber}/drivers/${params.id}`
			}),
			transformResponse: transformDriverResponse
		})
	})
});

export const { useFetchDriverQuery, useFetchDriversQuery, useLazyFetchDriversQuery } = driverSlice;
